import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  quizScreenContainer: {
    height: "100vh",
    backgroundColor: "#ecf2f1",
  },

  questionImg: {
    width: "150px",
    height: "150px",
    marginRight: "2.5rem",
    // position: 'absolute',
    zIndex: "5",
  },

  includedTitle: {
    color: "#003e4c",
    fontSize: "37px",
    marginRight: "2.5rem",
    fontWeight: "500",
    fontFamily: "Oswald",
    [mobileScreen(theme)]: {
      marginRight: "1.5rem",
      fontSize: "22px",
    },
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
  },

  dropImageStyle: {
    width: "400px",
    height: "100px",
    [mobileScreen(theme)]: {
      width: "230px",
      height: "40px",
    },
  },

  dropImageContainer: {
    height: "100px",
    margin: "5px 0",
    [mobileScreen(theme)]: {
      margin: "10px 0",
      height: "40px",
    },
  },

  draggableDrop: {
    border: "3px solid #003e4c",
    borderRadius: "6px",
    backgroundColor: "#fff",
    width: "410px",
  },

  answerTitleIcon: {
    width: "90px",
    height: "40px",
    marginRight: "1.5rem",
  },

  answerTitleContainer: {
    backgroundColor: "#003e4c",
    padding: "0.7rem 1rem",
  },

  answerTitleText: {
    color: "#fff",
    fontSize: "25px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  answerDescContainer: {
    padding: "0 1rem 1rem 1rem",
    height: "210px",
  },

  droppableCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    marginTop: "1rem",
    border: "3px dashed #003e4c",
  },

  droppableAnswer: {
    width: "79px",
    height: "79px",
    borderRadius: "50%",
    marginTop: "1rem",
  },

  submitButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    margin: "24px 0",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      margin: "5px 0",
      padding: "0px 15px",
      fontSize: "18px",
    },
  },
});

export default styles;
